/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Trust_No_CardInputs */

const es_home_hero_trust_no_card = /** @type {(inputs: Home_Hero_Trust_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin tarjeta de crédito`)
};

const en_home_hero_trust_no_card = /** @type {(inputs: Home_Hero_Trust_No_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit card required`)
};

/**
* | output |
* | --- |
* | "No credit card required" |
*
* @param {Home_Hero_Trust_No_CardInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_trust_no_card = /** @type {((inputs?: Home_Hero_Trust_No_CardInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Trust_No_CardInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_trust_no_card(inputs)
	return en_home_hero_trust_no_card(inputs)
});
export { home_hero_trust_no_card as "home.hero.trust_no_card" }